import * as types from '../actions/types';

export default (state = true, { type }) => {
    switch (type) {
        case types.TOGGLE_VISIBILITY_NUMBERS:
            return !state;
        default:
            return state;
    }
};
